import React from 'react';
import PropTypes from 'prop-types';
import StatusBadge from './StatusBadge';
import StepHeader from '../../includes/StepHeader';
import ViewBacsHistory from './sme/ViewBacsHistory';
import PaymentStatusStore from '../../stores/PaymentStatusStore';
import PrintHelper from 'print-helper-lib';
import { getBrandId } from '../../utils/BrandUtils';
import StatusBadgeSME from './sme/StatusBadgeSME';
import ViewIFTHistory from './sme/ViewIFTHistory';
import ViewChapsHistory from './sme/ViewChapsHistory';
import { paymentTypes } from '../../constants/StringConstants';
import envConfig from '../../../static/config';
import { VerticalReviewTable } from 'web-ui-components/lib/layout/tables';
import { SectionHeading } from 'web-ui-components/lib/typography/headings';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';

const { TYPE_BACS_DEBIT, TYPE_BACS_CREDIT, TYPE_IFT, TYPE_CHAPS } =
  paymentTypes;

export const renderAccountDetails = (accNo, sort, accName) => {
  if (accNo && sort) {
    const accountDetails = `${sort} / ${accNo}`;
    return accName ? `${accName} / ${accountDetails}` : `${accountDetails}`;
  } else return accName || '';
};

export const renderStatusBadge = (status, isSMEUser) =>
  isSMEUser ? (
    <div className="web-ui-components">
      <StatusBadgeSME status={status} />
    </div>
  ) : (
    <StatusBadge status={status} />
  );
class ViewPaymentHistory extends React.Component {
  componentWillMount() {
    window.scroll(0, 0);
  }

  render() {
    const {
      paymentHistoryDetails,
      goBack,
      content,
      isSMEUser = false,
    } = this.props;
    const statusMsg = PaymentStatusStore.getMessageByStatusCode(
      paymentHistoryDetails.statusCode
    );
    const brandId = getBrandId(envConfig.brandId);
    const { type: paymentType } = paymentHistoryDetails;

    if (
      paymentType === TYPE_BACS_DEBIT ||
      paymentType === TYPE_BACS_CREDIT ||
      paymentType === TYPE_IFT ||
      paymentType === TYPE_CHAPS
    ) {
      return (
        <div className="view-payment-history">
          {(paymentType === TYPE_BACS_DEBIT ||
            paymentType === TYPE_BACS_CREDIT) && (
            <ViewBacsHistory
              historyDetails={paymentHistoryDetails}
              statusMsg={statusMsg}
              goBack={goBack}
            />
          )}
          {paymentType === TYPE_IFT && (
            <ViewIFTHistory
              brandId={brandId}
              historyDetails={paymentHistoryDetails}
              statusMsg={statusMsg}
              goBack={goBack}
              content={content}
            />
          )}
          {paymentType === TYPE_CHAPS && (
            <ViewChapsHistory
              brandId={brandId}
              historyDetails={paymentHistoryDetails}
              statusMsg={statusMsg}
              goBack={goBack}
              content={content}
            />
          )}
        </div>
      );
    }

    const statusData = [
      {
        headerText: 'Status',
        cellText: (
          <div>
            {renderStatusBadge(paymentHistoryDetails.status, isSMEUser)}
            <StandardBody>
              <p>{statusMsg}</p>
            </StandardBody>
          </div>
        ),
      },
    ];

    const paymentData = [
      {
        headerText: 'From',
        cellText: renderAccountDetails(
          paymentHistoryDetails.fromAccountAccountNumber,
          paymentHistoryDetails.fromAccountSortCode,
          paymentHistoryDetails.fromAccountName
        ),
      },
      {
        headerText: 'To',
        cellText: renderAccountDetails(
          paymentHistoryDetails.toAccountAccountNumber,
          paymentHistoryDetails.toAccountSortCode,
          paymentHistoryDetails.toAccountName
        ),
      },
      {
        headerText: 'Amount',
        cellText: paymentHistoryDetails.amount,
      },
      {
        headerText: 'Reference',
        cellText: paymentHistoryDetails.reference,
      },
      {
        headerText: 'Date',
        cellText: paymentHistoryDetails.createdDate,
      },
      {
        ...(paymentHistoryDetails.createdBy && {
          headerText: 'Created by',
          cellText: paymentHistoryDetails.createdBy,
        }),
      },
      {
        ...(paymentHistoryDetails.authorisedBy && {
          headerText: 'Authorised by',
          cellText: paymentHistoryDetails.authorisedBy,
        }),
      },
    ];

    const filteredPaymentData = paymentData.filter(
      (row) => Object.keys(row).length !== 0
    );

    return (
      <div className="view-payment-history">
        <StepHeader
          onClick={goBack}
          headerCrumbsMessage="Back"
          headerTitle={'Payment Detail'}
          showheaderCrumbs
        />
        <SectionHeading>Bank acknowledgement details</SectionHeading>
        <PrintHelper
          className="web-ui-components"
          brandId={brandId}
          showPrintTopIcon
          showPrintBottomIcon={false}
        />
        <VerticalReviewTable data={statusData} />
        <SectionHeading>Your payment details</SectionHeading>
        <VerticalReviewTable data={filteredPaymentData} />
        <NavigationButton.Secondary labelText="Back" onClick={goBack} />
      </div>
    );
  }
}
ViewPaymentHistory.propTypes = {
  content: PropTypes.object,
  paymentHistoryDetails: PropTypes.object,
  goBack: PropTypes.func,
  isSMEUser: PropTypes.bool,
};

ViewPaymentHistory.defaultProps = {
  content: {},
};
export default ViewPaymentHistory;
